﻿import { Inject, IComponent, Component } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService";
import { CollectionResult, IResourceLink } from "../../interfaces/iFqs";
import { CompactServiceCase, SearchInfo, SearchData, Severity, Status, Environment } from "../../models/serviceCase";
import { ControlBase } from "../general/controlBase";
import { IsProcessingService } from "../../services/isProcessingService";
import { TranslationService } from "../../services/TranslationService";
import { CacheService } from "../../services/cache";
import { SaveDialog } from "../general/savedialog";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils";
import { DialogService } from "../../services/dialogService";
import { LogService } from "../../services/logService";
import { CaseType, Priority } from "../../models/serviceCase";
import { User } from "../../models/user";
import { Person, CompactPerson } from "../../models/person";
import { WebLink } from "../../models/base";
import { Home } from "../home";
import * as XLSX from "xlsx";
import { ExportService } from "../../services/exportToExcelService";
import { IdentityLink } from "../../services/fqsService";
import { ServiceUtils } from "../../services/serviceBase";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "search",
    templateUrl: "views/search.html",
    require: {
        application: "^application",
        home: "^home"
    }
})

export class Search extends ControlBase {
    constructor(
        @Inject('$timeout') $timeout: ng.ITimeoutService,
        @Inject('$rootRouter') rootRouter: angular.Router,
        @Inject() saveDialog: SaveDialog,
        @Inject() authorizationService: AuthorizationService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$element') protected $element: ng.IRootElementService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject() private cacheService: CacheService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject() private translationService: TranslationService,
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject() private logService: LogService,
        @Inject() private dialogService: DialogService,
        @Inject() private exportService: ExportService
    ) {
        super(saveDialog, rootRouter, $timeout, authorizationService);
    }

    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
    }

    public async $routerOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
    }

    private home: Home;
    private ServiceCases: CollectionResult<CompactServiceCase>;
    private searchPhrase: string;
    private searchData: SearchData = {};
    private application: Application;
    private tomuch: boolean = false;
    private searchInfo: SearchInfo = null;
    public SearchResult: CompactServiceCase[];
    public SearchResultCount: number;
    private searchResultPageCount: number;
    public showtextnoresults: boolean;
    private customers: any[] = [];
    private nowdate: Date;

    async $onInit() {
        this.clearAll();
        this.showtextnoresults = false;
        this.nowdate = new Date();
        this.nowdate.setHours(0, 0, 0, 0);
        this.home.fullMenu = false;

        this.searchInfo = await this.serviceCaseService.SearchInfo(this.application.selectedCustomers.map(x => <any>(x.key)));
        this.searchData = this.cacheService.getValue<SearchData>("search.extended.criteria") || {};
        this.searchResultPageCount = this.cacheService.getValue<number>("search.extended.resultsPageCount") || null;
        this.tomuch = this.checkTooManyResults();

        this.issuedToDate = this.searchData.createdBefore ? new Date(this.searchData.createdBefore).addDays(-1) : undefined;
        this.issuedFromDate = this.searchData.createdOnOrAfter ? new Date(this.searchData.createdOnOrAfter) : undefined;

        this.modifiedToDate = this.searchData.modifiedBefore ? new Date(this.searchData.modifiedBefore).addDays(-1) : undefined;
        this.modifiedFromDate = this.searchData.modifiedOnOrAfter ? new Date(this.searchData.modifiedOnOrAfter) : undefined;

        this.deadlineToDate = this.searchData.deadlineBefore ? new Date(this.searchData.deadlineBefore).addDays(-1) : undefined;
        this.deadlineFromDate = this.searchData.deadlineOnOrAfter ? new Date(this.searchData.deadlineOnOrAfter) : undefined;

        this.rememberToDate = this.searchData.rememberBefore ? new Date(this.searchData.rememberBefore).addDays(-1) : undefined;
        this.rememberFromDate = this.searchData.rememberOnOrAfter ? new Date(this.searchData.rememberOnOrAfter) : undefined;

        this.followedBy = this.searchData.watchedById ? IdentityLink.fromLink(this.searchData.watchedById) : undefined;
        this.reportedBy = this.searchData.createdById ? IdentityLink.fromLink(this.searchData.createdById) : undefined;

        this.highlightMenuItem = 'home';
        this.searchPhrase = this.application.simpleSearchString;
        if (this.searchPhrase && this.searchPhrase.length > 0) {
            if (isNaN(Number(this.searchPhrase)))
                this.searchData.title = this.searchPhrase;
            else
                this.searchData.caseNumber = this.searchPhrase;
            this.application.simpleSearchString = "";
        }

        this.caseStatuses = this.searchData.caseStatuses ? this.searchData.caseStatuses.map(key => { return { key: key, text: "" }; }) : undefined;
        this.caseEnvironments = this.searchData.environments ? this.searchData.environments.map(key => { return { key: key, text: "" }; }) : undefined;

        let applicationCustomers = this.application.selectedCustomers;
        if (applicationCustomers.length != 1) {
            let cachedCustomers = this.cacheService.getValue<any>("search.extended.customers") || [];
            let custs = applicationCustomers.length > 0 ? cachedCustomers.filter(cc => applicationCustomers.some(ac => ac.key == cc)) : cachedCustomers;
            this.customers = custs;
        } else {
            this.customers = applicationCustomers.map(c => c.key);
        }
    }

    $onDestroy() {
        this.highlightMenuItem = '';
        this.cacheService.setValue<SearchData>("search.extended.criteria", this.searchData);
        this.cacheService.setValue<any>("search.extended.customers", this.customers);
        this.cacheService.setValue<boolean>("search.extended.hasresults", (this.SearchResult && this.SearchResult.length > 0));
        this.cacheService.setValue<number>("search.extended.resultsPageCount", (this.searchResultPageCount));
    }

    public clearAll() {

        this.customers = [];
        this.searchData = {
            severities: [],
            caseStatuses: [],
            caseTypes: [],
            environments: [],
            priorities: []
        };
        this.caseEnvironments = [];
        this.caseSeverities = [];
        this.casePriorities = [];
        this.caseStatuses = [];
        this.issuedToDate = null;
        this.issuedFromDate = null;
        this.modifiedToDate = null;
        this.modifiedFromDate = null;
        this.deadlineToDate = null;
        this.deadlineFromDate = null;
        this.rememberToDate = null;
        this.rememberFromDate = null;
        this.reportedBy = null;
        this.followedBy = null;
        this.customerchanged([]);
        this.casetypeschanged([]);
        this.myServiceCasesChanged(false);
        this.collapseSearchField = false;

        this.$rootScope.$emit('eventCleared');

        this.$timeout(() => {
            const focusElements = this.$element[0]
                .getElementsByClassName('focus').item(0)
                .getElementsByClassName('numbereditbox').item(0);

            if (focusElements) {
                focusElements.focus();
            }
        });
    }

    public get canSearchOnRememberMe(): boolean {
        return this.authorizationService.currentRoleIn(["SD", "FQS"]);
    }

    public async search() {
        await this.$timeout();
        await this.$timeout();
        await this.$timeout();
        this.showtextnoresults = false;
        var custs = this.customers.length > 0 ? this.customers : this.application.selectedCustomers.map(v => v.key);
        try {
            this.isProcessingService.StartProcessing();
            var result = await this.serviceCaseService.AdvancedSearch(this.searchData, custs, 100, 0);
            this.processResults(result);
            this.collapseSearchField = true;
        } catch (error) {
            if (ServiceUtils.IsUnauthorizedResponse(error)) {
                return;
            }
            this.application.setSeqUrl(error);
            this.logService.error('Search', 'Error while searching', error);
            await this.dialogService.showErrorDialog('error', 'ERROR', 'SEARCH_ERROR', { errorResult: error, translate: true });
        } finally {
            this.showtextnoresults = true;
            this.isProcessingService.StopProcessing();
        }
    }

    private rawSearchResult: CompactServiceCase[] = [];

    private user: User;
    public get myservicecases() {
        if (this.user === undefined) {
            this.user = null;
            this.application.user.then(user => this.user = user);
        }
        return this.user && this.searchData && this.searchData.createdBy && this.searchData.createdBy == this.user.personId.ref;
    }

    public followedBy: IdentityLink;
    public followedByChanged(person: CompactPerson) {
        if (person) {
            this.searchData.watchedById = person.id;
        } else {
            this.searchData.watchedById = undefined;
        }
    }
    public get hideFollowedByFiqas() {
        return !this.user || !this.user.isFiqasEmployee;
    }

    public reportedBy: IdentityLink;
    public reportedByChanged(person: CompactPerson) {
        if (person) {
            this.searchData.createdById = person.id;
        } else {
            this.searchData.createdById = undefined;
        }
    }

    public async myServiceCasesChanged(active: boolean) {
        var user = await this.application.user;
        this.searchData.createdById = active ? user.personId : undefined;
    }

    private processResults(result: CollectionResult<CompactServiceCase>) {
        this.searchResultPageCount = result.pageCount;
        this.tomuch = this.checkTooManyResults();
        this.rawSearchResult = result.items;
        this.filterAccounts(this.application.selectedCustomers);
    }

    private checkTooManyResults() {
        return !!this.searchResultPageCount && this.searchResultPageCount > 1;
    }

    private filterAccounts(selected) {
        this.SearchResult = this.rawSearchResult.filter(x => selected.some(y => y.key == x.customer.href.replace('customer/', '')));
    }

    public back() {
        this.$window.history.back();
    }

    public caseidchanged(val: string) {
        this.searchData.caseNumber = val;
    }

    public titlechanged(val: string) {
        this.searchData.title = val;
    }

    public descriptionchanged(val: string) {
        this.searchData.description = val;
    }

    public custrefchanged(val: string) {
        this.searchData.customerRef = val;
    }

    public correspondencechanged(val: string) {
        this.searchData.correspondenceContent = val;
    }

    public customerchanged(customerKeys: any[]) {
        if (customerKeys === undefined)
            return;
        this.customers = customerKeys;
    }

    public prioritychanged(priorities: { key: Priority, text: string }[]) {
        if (priorities === undefined)
            return;
        this.casePriorities = priorities;
        this.searchData.priorities = priorities.map( k => k.key);
    }

    public casePriorities: { key: Priority, text: string }[];

    public environmentchanged(environments: { key: Environment, text: string }[]) {
        if (environments === undefined)
            return;
        this.caseEnvironments = environments;
        this.searchData.environments = environments.map( k => k.key);
    }

    public caseEnvironments: { key: Environment, text: string }[];

    public statuseschanged(statuses: { key: Status, text: string }[]) {
        if (statuses === undefined)
            return;
        this.caseStatuses = statuses;
        this.searchData.caseStatuses = statuses.map(k => k.key);
    }

    public caseStatuses: { key: Status, text: string }[];

    public casetypeschanged(casetypes: CaseType[]) {
        if (casetypes === undefined)
            return;
        this.searchData.caseTypes = casetypes;
    }

    public severitychanged(severities: { key: Severity, text: string }[]) {
        if (severities === undefined)
            return;
        this.caseSeverities = severities;
        this.searchData.severities = severities.map(k => k.key);
    }

    public caseSeverities: { key: Severity, text: string }[];

    private issuedFromDate: Date;
    public issuedfromdatechanged(date: Date) {
        this.issuedFromDate = date;
        if (date != null) {
            var ndate = date.clone();
            this.searchData.createdOnOrAfter = ndate.toISODateString();
        } else {
            this.searchData.createdOnOrAfter = undefined;
        }
    }

    private issuedToDate: Date;
    public issuedtodatechanged(date: Date) {
        this.issuedToDate = date;
        if (date != null) {
            var ndate = date.clone();
            ndate.setHours(0, 0, 0, 0);
            ndate.setDate(date.getDate() + 1);
            this.searchData.createdBefore = ndate.toISODateString();
        } else {
            this.searchData.createdBefore = undefined;
        }
    }

    private get issuedMaxDate(): Date {
        return this.issuedToDate ? this.issuedToDate : this.nowdate;
    }

    private modifiedFromDate: Date;
    public modifiedfromdatechanged(date: Date) {
        this.modifiedFromDate = date;
        if (date != null) {
            var ndate = date.clone();
            this.searchData.modifiedOnOrAfter = ndate.toISODateString();
        } else {
            this.searchData.modifiedOnOrAfter = undefined;
        }
    }

    private modifiedToDate: Date;
    public modifiedtodatechanged(date: Date) {
        this.modifiedToDate = date;
        if (date != null) {
            var ndate = date.clone();
            ndate.setHours(0, 0, 0, 0);
            ndate.setDate(date.getDate() + 1);
            this.searchData.modifiedBefore = ndate.toISODateString();
        } else {
            this.searchData.modifiedBefore = undefined;
        }
    }

    private get modifiedMaxDate(): Date {
        return this.modifiedToDate ? this.modifiedToDate : this.nowdate;
    }

    private deadlineFromDate: Date;
    public deadlinefromdatechanged(date: Date) {
        this.deadlineFromDate = date;
        if (date != null) {
            var ndate = date.clone();
            this.searchData.deadlineOnOrAfter = ndate.toISODateString();
        } else {
            this.searchData.deadlineOnOrAfter = undefined;
        }
    }

    private deadlineToDate: Date;
    public deadlinetodatechanged(date: Date) {
        this.deadlineToDate = date;
        if (date != null) {
            var ndate = date.clone();
            ndate.addDays(1);
            this.searchData.deadlineBefore = ndate.toISODateString();
        } else {
            this.searchData.deadlineBefore = undefined;
        }
    }

    private get deadlineMaxDate(): Date {
        return this.deadlineToDate;
    }

    private rememberFromDate: Date;
    public rememberfromdatechanged(date: Date) {
        this.rememberFromDate = date;
        if (date != null) {
            var ndate = date.clone();
            this.searchData.rememberOnOrAfter = ndate.toISODateString();
        } else {
            this.searchData.rememberOnOrAfter = undefined;
        }
    }

    private rememberToDate: Date;
    public remembertodatechanged(date: Date) {
        this.rememberToDate = date;
        if (date != null) {
            var ndate = date.clone();
            ndate.addDays(1);
            this.searchData.rememberBefore = ndate.toISODateString();
        } else {
            this.searchData.rememberBefore = undefined;
        }
    }

    private get rememberMaxDate(): Date {
        return this.rememberToDate;
    }

    public keypress($event: KeyboardEvent) {
        if ($event.keyCode == KeyCodes.enter || $event.code == KeyboardEventCode.enter) {
            $event.preventDefault();
            this.search();
            $event.stopPropagation();
        }
    }

    private _collapseSearchField: boolean;
    public get collapseSearchField(): boolean {
        return this._collapseSearchField;
    }
    public set collapseSearchField(val: boolean) {
        this._collapseSearchField = val;
    }

    public collapsefieldskeydown($event: KeyboardEvent) {
        if ($event.keyCode === 0) {
            switch ($event.code) {
                case KeyboardEventCode.space:
                    $event.preventDefault();
                    break;
            }

        } else {
            switch ($event.keyCode) {
                case KeyCodes.space:
                    $event.preventDefault();
                    break;
            }
        }
    }

    public collapsefieldskeyup($event: KeyboardEvent) {
        if ($event.keyCode === 0) {
            switch ($event.code) {
                case KeyboardEventCode.space:
                    $event.preventDefault();
                    this.collapseSearchField = !this.collapseSearchField
                    break;
                case KeyboardEventCode.leftArrow:
                    $event.preventDefault();
                    this.collapseSearchField = true;
                    $event.stopPropagation();
                    break;
                case KeyboardEventCode.rightArrow:
                    $event.preventDefault();
                    this.collapseSearchField = false;
                    $event.stopPropagation();
                    break;
            }
        } else {
            switch ($event.keyCode) {
                case KeyCodes.space:
                    $event.preventDefault();
                    this.collapseSearchField = !this.collapseSearchField
                    break;
                case KeyCodes.leftArrow:
                    $event.preventDefault();
                    this.collapseSearchField = true;
                    $event.stopPropagation();
                    break;
                case KeyCodes.rightArrow:
                    $event.preventDefault();
                    this.collapseSearchField = false;
                    $event.stopPropagation();
                    break;
            }
        }
    }

    public async createXlsx() {
        var custs = this.customers.length > 0 ? this.customers : this.application.selectedCustomers.map(v => v.key);
        try {
            this.isProcessingService.StartProcessing();
            var result = await this.serviceCaseService.AdvancedExport(this.searchData, custs);
            this.processResults(result);
        } catch (error) {
            if (ServiceUtils.IsUnauthorizedResponse(error)) {
                return;
            }
            this.application.setSeqUrl(error);
            this.logService.error('Search', 'Error while searching', error);
            await this.dialogService.showErrorDialog('error', 'ERROR', 'SEARCH_ERROR', { errorResult: error, translate: true });
        } finally {
            this.showtextnoresults = true;
            this.isProcessingService.StopProcessing();
        }
        this.exportService.saveExcelFromJson(this.SearchResult, null);
    }
}
